// @flow
import React from 'react'

import { ErrorText } from './ErrorText'

export const FormError = ({ error = '', ...props }) => (
  error ? <ErrorText error={error} {...props} /> : null
)

export const GlobalFormError = ({ form }) => {
  const { error, submitError } = form.getState()
  const finalError = error || submitError

  return finalError ? <ErrorText error={finalError} /> : null
}
